<div class="top">
    <div class="disease-header fs6_5 ff_CentraleSansBold">{{disease}}</div>
    <ispm-pathway-actions [config]="pathwayActionsConfig"></ispm-pathway-actions>
    <ispm-curation-workflow-stepper [currentRevision]="currentRevision"
                                    [currentWorkflow]="currentWorkflow"
                                    [isPatientContext]="isPatientContext"
                                    class="scroll">
    </ispm-curation-workflow-stepper>
</div>
<ispm-header-info [infoOrigin]="infoOrigin"></ispm-header-info>
